import { createContext, useContext } from "react";

/**
 * Whether Finalize has been attempted on this draft.
 *
 * The design has two kinds of error and shows them at different times: **what you typed is wrong**
 * appears the moment you type it, and **you have not filled this in** appears once you try to
 * finalize. The first needs no flag — a value that fails is a value that exists. This is the
 * second, and it is one boolean for the page.
 *
 * The registered fields do not need it: `trigger()` writes their errors when the attempt happens,
 * and react-hook-form shows them per field. The **row lists** do, because their inputs are not
 * registered and their rules are evaluated by the section itself — an empty incident-time row has
 * no content to hang a live error on, so without this the officer clicks "3 required fields left",
 * lands on Incident, and finds nothing marked.
 *
 * A context rather than a prop for the reason the form state itself is one: sections take no props
 * (README decision 3). Its value changes at most once per draft, so it costs nothing.
 */
const FinalizeAttemptContext = createContext(false);

export const FinalizeAttemptProvider = FinalizeAttemptContext.Provider;

export const useFinalizeAttempted = (): boolean =>
  useContext(FinalizeAttemptContext);
